import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, Clock, TrendingUp } from 'lucide-react';
export function CaseStudy() {
  return <Section background="ivory" className="relative overflow-hidden bg-purple-50" data-id="element-88" data-mp="35py11aca4en3">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-purple-100/30 rounded-full blur-3xl -ml-48 -mt-48" data-id="element-89" data-mp="3apkdhhka9quu"></div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center relative z-10" data-id="element-90" data-mp="3fnlxc4pj9u7d">
        {/* Left: Story */}
        <div className="order-2 lg:order-1" data-id="element-91" data-mp="3og5ypcx7mcvw">
          <FadeIn data-id="element-92" data-mp="3oh7etvt31pkh">
            <div className="text-sm uppercase tracking-widest text-purple-600 font-semibold mb-6" data-id="element-93" data-mp="3ogxw8tadakot">
              Case Study
            </div>
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-8 leading-tight" data-id="element-94" data-mp="297pkfxxh9e0">
              Meet Casie
            </h2>
          </FadeIn>

          <div className="space-y-6 text-lg text-charcoal/80 leading-relaxed" data-id="element-95" data-mp="78kf58g6ouka">
            <FadeIn delay={200} data-id="element-96" data-mp="2lrge58vvaf4s">
              <p data-id="element-97" data-mp="2lokgzmrufuhe">
                Casie is a high-performing executive. On paper, her life was
                thriving — leadership role, growing team, constant momentum.
              </p>
            </FadeIn>

            <FadeIn delay={300} data-id="element-98" data-mp="2bualvxbioi2z">
              <p data-id="element-99" data-mp="27rns3qvacn35">
                But behind the scenes, she was dealing with persistent fatigue,
                anxiety, and a sense that something wasn't quite right.
              </p>
            </FadeIn>

            <FadeIn delay={400} data-id="element-100" data-mp="2zj3af8pt7nnk">
              <p data-id="element-101" data-mp="2zitteamqsqu0">
                She saw multiple providers, waited weeks between appointments,
                and received fragmented, often conflicting advice. Nothing felt
                truly personalized — or complete.
              </p>
            </FadeIn>

            <FadeIn delay={500} data-id="element-102" data-mp="3n8o68s72afe9">
              <p className="font-medium text-charcoal" data-id="element-103" data-mp="3n8xqdz5fdsc1">
                Over time, she began to lose trust in the system.
              </p>
            </FadeIn>

            <FadeIn delay={600} data-id="element-104" data-mp="1gkf60h8nn761">
              <div className="pt-6 border-t border-charcoal/10" data-id="element-105" data-mp="1gk5o7gxrk6bf">
                <p className="text-2xl font-serif text-charcoal mb-4" data-id="element-106" data-mp="1lhfawotrq3vk">
                  Then she found Fem Entity.
                </p>
                <p data-id="element-107" data-mp="16rhuww5zskhg">
                  Within minutes, Casie was guided through a personalized intake
                  and matched with a curated network of trusted practitioners.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={700} data-id="element-108" data-mp="12sigmkydfbdc">
              <p className="italic" data-id="element-109" data-mp="12sqtwdyeoip2">
                For the first time, her care felt connected.
              </p>
            </FadeIn>

            <FadeIn delay={800} data-id="element-110" data-mp="nx2wb7nletu5">
              <p data-id="element-111" data-mp="st9taay0guzy">
                Her wellness plan adapted to her needs — integrating insights,
                tracking progress, and aligning her providers within one
                ecosystem.
              </p>
            </FadeIn>
          </div>
        </div>

        {/* Right: Visual + Results */}
        <div className="order-1 lg:order-2 space-y-8" data-id="element-112" data-mp="bjpeeqq6af1w">
          <FadeIn delay={200} data-id="element-113" data-mp="bi4iawo7mo1x">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-charcoal/10" data-id="element-114" data-mp="6lw6nt981czi">
              <img src="https://cdn.magicpatterns.com/uploads/czmN7x1t4juHwMujJGpE9F/pexels-rdne-5778469.jpg" alt="Professional woman working" className="w-full h-[400px] object-cover" data-id="element-115" data-mp="lasdxo3gelz2" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 to-transparent" data-id="element-116" data-mp="u95fpg9ombjd"></div>
            </div>
          </FadeIn>

          <FadeIn delay={400} data-id="element-117" data-mp="148wbdl9zawl1">
            <div className="glass-panel rounded-2xl p-8 space-y-6" data-id="element-118" data-mp="1483ct7l6bddz">
              <div className="flex items-center space-x-3 pb-4 border-b border-charcoal/10" data-id="element-119" data-mp="zabb5luq8cwl">
                <Clock className="w-5 h-5 text-purple-700" data-id="element-120" data-mp="3609dy3oh4sdx" />
                <h3 className="text-xl font-serif text-charcoal" data-id="element-121" data-mp="360rjxs0xukz1">
                  Within 90 Days
                </h3>
              </div>

              <div className="space-y-4" data-id="element-122" data-mp="32iu0k5f7x9ip">
                <div className="flex items-start space-x-3" data-id="element-123" data-mp="32hsgxck4zepd">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 mt-1 flex-shrink-0" data-id="element-124" data-mp="37h5bkjh91q2i" />
                  <div data-id="element-125" data-mp="3ch13vlgl3t28">
                    <div className="font-medium text-charcoal" data-id="element-126" data-mp="3cghy1347kv4k">
                      Her energy stabilized
                    </div>
                    <div className="text-sm text-charcoal/60" data-id="element-127" data-mp="3hf2y92jgnet0">
                      Consistent, sustainable vitality
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3" data-id="element-128" data-mp="2orox0s8qbx33">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 mt-1 flex-shrink-0" data-id="element-129" data-mp="2tpqex9uf5qcz" />
                  <div data-id="element-130" data-mp="2ygqe6lr0gkin">
                    <div className="font-medium text-charcoal" data-id="element-131" data-mp="2yi1rpda9d6my">
                      Her anxiety decreased
                    </div>
                    <div className="text-sm text-charcoal/60" data-id="element-132" data-mp="211cj90qsz64l">
                      Measurable reduction in stress markers
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3" data-id="element-133" data-mp="n4rxm04co0is">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 mt-1 flex-shrink-0" data-id="element-134" data-mp="j3pxzi6itmga" />
                  <div data-id="element-135" data-mp="e4d96rw3a5b2">
                    <div className="font-medium text-charcoal" data-id="element-136" data-mp="e3lerke8admd">
                      Her care became clear and consistent
                    </div>
                    <div className="text-sm text-charcoal/60" data-id="element-137" data-mp="46p2r4p4f9d2">
                      Unified, coordinated approach
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={600} data-id="element-138" data-mp="3rkuhvvqdy3nx">
            <div className="bg-charcoal text-ivory p-8 rounded-2xl" data-id="element-139" data-mp="3rk15ae4qwjxv">
              <div className="flex items-start space-x-4" data-id="element-140" data-mp="3mlr9q2f3zhbq">
                <TrendingUp className="w-6 h-6 text-purple-400 mt-1 flex-shrink-0" data-id="element-141" data-mp="3hllnx2visp1k" />
                <div data-id="element-142" data-mp="3hng1tx8djgw5">
                  <p className="text-lg font-serif mb-3" data-id="element-143" data-mp="3cmsdjjbj5e5m">
                    Today, Casie understands her health — and feels in control
                    of it.
                  </p>
                  <p className="text-ivory/70 text-sm leading-relaxed" data-id="element-144" data-mp="37xzos86aztwt">
                    Fem Entity didn't just give her access. It gave her clarity,
                    confidence, and continuity of care.
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}